import React from "react";

const SectionHeading = (props) => {
    return(
        <div className={"Global---Section-Heading  " + props.customClass}>
            <h6>{props.subHeading}</h6>
            <h2 className={"mb-3 " + props.customClass} >{props.heading}</h2>
        </div>
    );
}

export default SectionHeading;